import { render, staticRenderFns } from "./PermissionSelect.vue?vue&type=template&id=89e17512&scoped=true&"
import script from "./PermissionSelect.vue?vue&type=script&lang=js&"
export * from "./PermissionSelect.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSelect.vue?vue&type=style&index=0&id=89e17512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e17512",
  null
  
)

export default component.exports